// Setup › Workforce › Chief of Staff (COS-SLICE1): `/c/{slug}/setup/chief-of-staff`. The
// `agents` add-on (the page shows the add-on banner while it is off), managers (the Setup gate).
import { createRoute } from "@tanstack/react-router";
import { ChiefOfStaffScreen } from "../features/settings/chief-of-staff";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupChiefOfStaffRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "chief-of-staff",
  component: function SetupChiefOfStaffPage() {
    const { api } = setupChiefOfStaffRoute.useRouteContext();
    return <ChiefOfStaffScreen api={api} company={useCompany()} />;
  },
});
